// MT home dashboard (zone layout) strings: mtdOps. Keys use the "mtd-" prefix.
// Operations zone widgets (Forms in progress, My / All tickets) and the quick
// access rail (Calendar, Form favorites, Shortcuts, Shared links).
export default {
  en: {
    'mtd-my-equipment-tasks': 'My Equipment Tasks',
    'mtd-all-equipment-tasks': 'All Equipment Tasks',
    'mtd-pass-rate': 'Pass rate',
    'mtd-scheduled-forms': 'Scheduled forms',
    'mtd-sched-refresh': 'Refresh',
    'mtd-sched-open-my-forms': 'Open My forms',
    'mtd-sched-select-location': 'Select a location to see scheduled forms.',
    'mtd-sched-footer': '{completed} completed · {missed} missed',
    'mtd-sched-assigned-to-you': 'Assigned to you',
    'mtd-sched-in-progress': 'In progress',
    'mtd-sched-opens-at': 'Opens {time}',
    'mtd-sched-past-due': 'Past due',
    'mtd-sched-start': 'Start',
    'mtd-sched-due-at': 'Due {time}',
    'mtd-sched-cadence-hourly': 'Hourly',
    'mtd-sched-cadence-daily': 'Daily',
    'mtd-sched-cadence-weekly': 'Weekly',
    'mtd-sched-cadence-monthly': 'Monthly',
    'mtd-sched-cadence-recurring': 'Recurring',
    'mtd-sched-cadence-once': 'One-time',
    'mtd-sched-completed': 'Completed',
    'mtd-sched-past-due-count': '{n} past due',
    'mtd-sched-missed': 'Missed',
    'mtd-sched-upcoming': 'Upcoming',
    'mtd-sched-next-opens': 'Next opens {time}',
    'mtd-sched-progress': 'Progress',
    'mtd-sched-scheduled': 'Scheduled',
    'mtd-sched-none': 'No forms scheduled for this period',
    'mtd-sched-active': 'Active',
    'mtd-sched-done': 'Done',
    'mtd-sched-missed-count': '{n} missed',
    'mtd-sched-done-count': '{completed}/{total} done',
    'mtd-sched-of-total': 'of {n} scheduled',
    'mtd-sched-scope': 'Whose forms',
    'mtd-sched-scope-mine': 'My forms',
    'mtd-sched-scope-all': 'All forms',
    'mtd-forms-in-progress': 'Forms in progress',
    'mtd-nothing-in-progress': 'Nothing in progress',
    'mtd-start-from-favorites': 'Start a form from Form favorites.',
    'mtd-form-favorites': 'Form favorites',
    'mtd-all-forms': 'All forms ({n})',
    'mtd-my-tickets': 'My tickets',
    'mtd-all-tickets': 'All tickets',
    'mtd-open': 'Open',
    'mtd-open-tickets': 'Open tickets',
    'mtd-next-task-due': 'Next task due · {date}',
    'mtd-next-task-due-none': 'Next task due · none upcoming',
    'mtd-maintenance-scheduled': 'Maintenance · {n} scheduled',
    'mtd-open-resource-library': 'Open resource library',
    'mtd-added-lc': 'added {date}',
    'mtd-shared-links': 'Shared links',
    'mtd-manage-links': 'Manage links',
    'mtd-no-shared-links':
      'No shared links have been added for your organization.',
    'mtd-loading': 'Loading…',
  },
  es: {
    'mtd-my-equipment-tasks': 'Mis tareas de equipos',
    'mtd-all-equipment-tasks': 'Todas las tareas de equipos',
    'mtd-pass-rate': 'Tasa de aprobación',
    'mtd-scheduled-forms': 'Formularios programados',
    'mtd-sched-refresh': 'Actualizar',
    'mtd-sched-open-my-forms': 'Abrir Mis formularios',
    'mtd-sched-select-location':
      'Seleccione una ubicación para ver los formularios programados.',
    'mtd-sched-footer': '{completed} completados · {missed} no realizados',
    'mtd-sched-assigned-to-you': 'Asignado a usted',
    'mtd-sched-in-progress': 'En curso',
    'mtd-sched-opens-at': 'Se abre {time}',
    'mtd-sched-past-due': 'Vencido',
    'mtd-sched-start': 'Iniciar',
    'mtd-sched-due-at': 'Vence {time}',
    'mtd-sched-cadence-hourly': 'Cada hora',
    'mtd-sched-cadence-daily': 'Diario',
    'mtd-sched-cadence-weekly': 'Semanal',
    'mtd-sched-cadence-monthly': 'Mensual',
    'mtd-sched-cadence-recurring': 'Recurrente',
    'mtd-sched-cadence-once': 'Única vez',
    'mtd-sched-completed': 'Completados',
    'mtd-sched-past-due-count': '{n} vencidos',
    'mtd-sched-missed': 'No realizados',
    'mtd-sched-upcoming': 'Próximos',
    'mtd-sched-next-opens': 'El próximo se abre {time}',
    'mtd-sched-progress': 'Progreso',
    'mtd-sched-scheduled': 'Programados',
    'mtd-sched-none': 'No hay formularios programados para este período',
    'mtd-sched-active': 'Activo',
    'mtd-sched-done': 'Hecho',
    'mtd-sched-missed-count': '{n} no realizados',
    'mtd-sched-done-count': '{completed}/{total} hechos',
    'mtd-sched-of-total': 'de {n} programados',
    'mtd-sched-scope': 'Formularios de quién',
    'mtd-sched-scope-mine': 'Mis formularios',
    'mtd-sched-scope-all': 'Todos los formularios',
    'mtd-forms-in-progress': 'Formularios en curso',
    'mtd-nothing-in-progress': 'Nada en curso',
    'mtd-start-from-favorites':
      'Inicie un formulario desde Formularios favoritos.',
    'mtd-form-favorites': 'Formularios favoritos',
    'mtd-all-forms': 'Todos los formularios ({n})',
    'mtd-my-tickets': 'Mis tickets',
    'mtd-all-tickets': 'Todos los tickets',
    'mtd-open': 'Abiertos',
    'mtd-open-tickets': 'Abrir tickets',
    'mtd-next-task-due': 'Próxima tarea · {date}',
    'mtd-next-task-due-none': 'Próxima tarea · ninguna próxima',
    'mtd-maintenance-scheduled': 'Mantenimiento · {n} programadas',
    'mtd-open-resource-library': 'Abrir biblioteca de recursos',
    'mtd-added-lc': 'agregado {date}',
    'mtd-shared-links': 'Enlaces compartidos',
    'mtd-manage-links': 'Administrar enlaces',
    'mtd-no-shared-links':
      'No se han agregado enlaces compartidos para su organización.',
    'mtd-loading': 'Cargando…',
  },
  fr: {
    'mtd-my-equipment-tasks': 'Mes tâches d’équipement',
    'mtd-all-equipment-tasks': 'Toutes les tâches d’équipement',
    'mtd-pass-rate': 'Taux de réussite',
    'mtd-scheduled-forms': 'Formulaires planifiés',
    'mtd-sched-refresh': 'Actualiser',
    'mtd-sched-open-my-forms': 'Ouvrir Mes formulaires',
    'mtd-sched-select-location':
      'Sélectionnez un emplacement pour voir les formulaires planifiés.',
    'mtd-sched-footer': '{completed} complétés · {missed} manqués',
    'mtd-sched-assigned-to-you': 'Assigné à vous',
    'mtd-sched-in-progress': 'En cours',
    'mtd-sched-opens-at': 'Ouvre {time}',
    'mtd-sched-past-due': 'En retard',
    'mtd-sched-start': 'Commencer',
    'mtd-sched-due-at': 'Échéance {time}',
    'mtd-sched-cadence-hourly': 'Toutes les heures',
    'mtd-sched-cadence-daily': 'Quotidien',
    'mtd-sched-cadence-weekly': 'Hebdomadaire',
    'mtd-sched-cadence-monthly': 'Mensuel',
    'mtd-sched-cadence-recurring': 'Récurrent',
    'mtd-sched-cadence-once': 'Ponctuel',
    'mtd-sched-completed': 'Complétés',
    'mtd-sched-past-due-count': '{n} en retard',
    'mtd-sched-missed': 'Manqués',
    'mtd-sched-upcoming': 'À venir',
    'mtd-sched-next-opens': 'Prochain : {time}',
    'mtd-sched-progress': 'Progression',
    'mtd-sched-scheduled': 'Planifiés',
    'mtd-sched-none': 'Aucun formulaire planifié pour cette période',
    'mtd-sched-active': 'Actif',
    'mtd-sched-done': 'Terminé',
    'mtd-sched-missed-count': '{n} manqués',
    'mtd-sched-done-count': '{completed}/{total} terminés',
    'mtd-sched-of-total': 'sur {n} planifiés',
    'mtd-sched-scope': 'Formulaires de qui',
    'mtd-sched-scope-mine': 'Mes formulaires',
    'mtd-sched-scope-all': 'Tous les formulaires',
    'mtd-forms-in-progress': 'Formulaires en cours',
    'mtd-nothing-in-progress': 'Rien en cours',
    'mtd-start-from-favorites':
      'Commencez un formulaire depuis Formulaires favoris.',
    'mtd-form-favorites': 'Formulaires favoris',
    'mtd-all-forms': 'Tous les formulaires ({n})',
    'mtd-my-tickets': 'Mes tickets',
    'mtd-all-tickets': 'Tous les tickets',
    'mtd-open': 'Ouverts',
    'mtd-open-tickets': 'Ouvrir les tickets',
    'mtd-next-task-due': 'Prochaine tâche · {date}',
    'mtd-next-task-due-none': 'Prochaine tâche · aucune à venir',
    'mtd-maintenance-scheduled': 'Maintenance · {n} planifiées',
    'mtd-open-resource-library': 'Ouvrir la bibliothèque de ressources',
    'mtd-added-lc': 'ajouté le {date}',
    'mtd-shared-links': 'Liens partagés',
    'mtd-manage-links': 'Gérer les liens',
    'mtd-no-shared-links':
      "Aucun lien partagé n'a été ajouté pour votre organisation.",
    'mtd-loading': 'Chargement…',
  },
  'fr-ca': {
    'mtd-my-equipment-tasks': 'Mes tâches d’équipement',
    'mtd-all-equipment-tasks': 'Toutes les tâches d’équipement',
    'mtd-pass-rate': 'Taux de réussite',
    'mtd-scheduled-forms': 'Formulaires planifiés',
    'mtd-sched-refresh': 'Actualiser',
    'mtd-sched-open-my-forms': 'Ouvrir Mes formulaires',
    'mtd-sched-select-location':
      'Sélectionnez un emplacement pour voir les formulaires planifiés.',
    'mtd-sched-footer': '{completed} complétés · {missed} manqués',
    'mtd-sched-assigned-to-you': 'Assigné à vous',
    'mtd-sched-in-progress': 'En cours',
    'mtd-sched-opens-at': 'Ouvre {time}',
    'mtd-sched-past-due': 'En retard',
    'mtd-sched-start': 'Commencer',
    'mtd-sched-due-at': 'Échéance {time}',
    'mtd-sched-cadence-hourly': 'Toutes les heures',
    'mtd-sched-cadence-daily': 'Quotidien',
    'mtd-sched-cadence-weekly': 'Hebdomadaire',
    'mtd-sched-cadence-monthly': 'Mensuel',
    'mtd-sched-cadence-recurring': 'Récurrent',
    'mtd-sched-cadence-once': 'Ponctuel',
    'mtd-sched-completed': 'Complétés',
    'mtd-sched-past-due-count': '{n} en retard',
    'mtd-sched-missed': 'Manqués',
    'mtd-sched-upcoming': 'À venir',
    'mtd-sched-next-opens': 'Prochain : {time}',
    'mtd-sched-progress': 'Progression',
    'mtd-sched-scheduled': 'Planifiés',
    'mtd-sched-none': 'Aucun formulaire planifié pour cette période',
    'mtd-sched-active': 'Actif',
    'mtd-sched-done': 'Terminé',
    'mtd-sched-missed-count': '{n} manqués',
    'mtd-sched-done-count': '{completed}/{total} terminés',
    'mtd-sched-of-total': 'sur {n} planifiés',
    'mtd-sched-scope': 'Formulaires de qui',
    'mtd-sched-scope-mine': 'Mes formulaires',
    'mtd-sched-scope-all': 'Tous les formulaires',
    'mtd-forms-in-progress': 'Formulaires en cours',
    'mtd-nothing-in-progress': 'Rien en cours',
    'mtd-start-from-favorites':
      'Commencez un formulaire depuis Formulaires favoris.',
    'mtd-form-favorites': 'Formulaires favoris',
    'mtd-all-forms': 'Tous les formulaires ({n})',
    'mtd-my-tickets': 'Mes billets',
    'mtd-all-tickets': 'Tous les billets',
    'mtd-open': 'Ouverts',
    'mtd-open-tickets': 'Ouvrir les billets',
    'mtd-next-task-due': 'Prochaine tâche · {date}',
    'mtd-next-task-due-none': 'Prochaine tâche · aucune à venir',
    'mtd-maintenance-scheduled': 'Entretien · {n} planifiées',
    'mtd-open-resource-library': 'Ouvrir la bibliothèque de ressources',
    'mtd-added-lc': 'ajouté le {date}',
    'mtd-shared-links': 'Liens partagés',
    'mtd-manage-links': 'Gérer les liens',
    'mtd-no-shared-links':
      "Aucun lien partagé n'a été ajouté pour votre organisation.",
    'mtd-loading': 'Chargement…',
  },
};
